import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiContainer, SuiTextInput, SuiToggle, SuiTooltip } from '@splashthat/sui';

import { getFormNodeUrlParamName } from 'common/entities/formNode/selectors';
import { updateFormNodeValue } from 'common/compounds/FormBuilder/actions/nodeActions';
import disableWhenLocked from './disableWhenLocked';

const URL_PARAMS_LABEL = 'URL Parameter';
const URL_PARAM_NAME_LABEL = 'Parameter Name';

const URL_PARAM_PLACEHOLDER = 'param_name';
const URL_PARAM_TOOLTIP = `
    Capture URL Parameters (Query Strings) from the page the person is on when filling out the form.
    They can be used to populate both visible and hidden fields.
`;

class UrlParamControl extends React.Component {
    state = {
        hasUrlParam: !!this.props.urlParamName,
    };

    static propTypes = {
        formNodeId: PropTypes.string.isRequired,
        urlParamName: PropTypes.string,
        updateFormNodeValue: PropTypes.func.isRequired,
        /** disabled is passed when form node editing is locked */
        disabled: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        urlParamName: null,
    };

    handleOnChangeUrlName = (event, value) => {
        this.props.updateFormNodeValue(this.props.formNodeId, 'urlParamName', value || null);
    };

    handleOnChangeToggle = () => {
        this.setState(
            (prevState) => ({
                hasUrlParam: !prevState.hasUrlParam,
            }),
            () => {
                !this.state.hasUrlParam && this.props.updateFormNodeValue(this.props.formNodeId, 'urlParamName', null);
            },
        );
    };

    render() {
        const { urlParamName, disabled } = this.props;

        return (
            <SuiContainer variation="flex-group flex-inherit flex-vertical">
                <SuiContainer variation="flex-group">
                    <SuiToggle
                        label={URL_PARAMS_LABEL}
                        onChange={this.handleOnChangeToggle}
                        enabled={this.state.hasUrlParam}
                        disabled={disabled}
                    />
                </SuiContainer>
                {this.state.hasUrlParam && (
                    <SuiContainer variation="flex-group">
                        <SuiTextInput
                            label={
                                <SuiContainer variation="flex-horizontal-left">
                                    {URL_PARAM_NAME_LABEL}
                                    &nbsp;
                                    <SuiTooltip>{URL_PARAM_TOOLTIP}</SuiTooltip>
                                </SuiContainer>
                            }
                            fullWidth
                            defaultValue={urlParamName}
                            onChange={this.handleOnChangeUrlName}
                            placeholder={URL_PARAM_PLACEHOLDER}
                            disabled={disabled}
                        />
                    </SuiContainer>
                )}
            </SuiContainer>
        );
    }
}

// -------------------
// Connected component

const mapStateToProps = (state, props) => {
    const urlParamName = getFormNodeUrlParamName(state, props.formNodeId);

    return {
        formNodeId: props.formNodeId,
        urlParamName,
    };
};

const mapDispatchToProps = {
    updateFormNodeValue,
};

const ConnectedUrlParamControl = connect(mapStateToProps, mapDispatchToProps)(disableWhenLocked(UrlParamControl));

ConnectedUrlParamControl.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedUrlParamControl.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedUrlParamControl;
